import { render, staticRenderFns } from "./listInvoiceBranchDetail.vue?vue&type=template&id=5592c1b2"
import script from "./listInvoiceBranchDetail.vue?vue&type=script&lang=js"
export * from "./listInvoiceBranchDetail.vue?vue&type=script&lang=js"
import style0 from "./listInvoiceBranchDetail.vue?vue&type=style&index=0&id=5592c1b2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports